module.exports = __webpack_public_path__ + "static/mustella-1a1acb0219f4d0e17e4e00098296cfb8.png";